/* Shared unread-notifications count for the client nav badge.
   Pages that load the user's notifications (Dashboard, Notifications) compute the
   count and store it here; the Sidebar/MobileNav read it and subscribe to changes.
   Uses the same localStorage read-set the Notifications page maintains. */

const KEY_COUNT = 'connct_unread_count';
const KEY_READ = 'connct_read_notifications'; // must match Notifications.tsx READ_STORAGE_KEY

export function computeUnread(notifications: any): number {
  if (!notifications || typeof notifications !== 'object') return 0;
  let readSet = new Set<string>();
  try { readSet = new Set(JSON.parse(localStorage.getItem(KEY_READ) || '[]')); } catch { /* ignore */ }
  return Object.keys(notifications).filter(id => !readSet.has(id)).length;
}

export function setUnreadCount(n: number) {
  try { localStorage.setItem(KEY_COUNT, String(Math.max(0, n))); } catch { /* ignore */ }
  try { window.dispatchEvent(new Event('connct-unread')); } catch { /* ignore */ }
}

export function getUnreadCount(): number {
  try { return parseInt(localStorage.getItem(KEY_COUNT) || '0', 10) || 0; } catch { return 0; }
}
